import {
  Component,
  OnInit,
  Input,
  ComponentFactoryResolver,
  ChangeDetectorRef
} from '@angular/core';
import { YesNoDataEntity } from 'src/app/models/data-entities';
import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import { UntypedFormBuilder } from '@angular/forms';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-yes-no-data-entity-input',
    templateUrl: './yes-no-data-entity-input.component.html',
    styleUrls: ['./yes-no-data-entity-input.component.css'],
    standalone: false
})
export class YesNoDataEntityInputComponent extends DataEntityInputComponent
  implements OnInit {
  @Input() entity: YesNoDataEntity;
  checkBoxValue: boolean;

  constructor(
    public layoutService: LayoutService,
    componentFactoryResolver: ComponentFactoryResolver,
    private _fb: UntypedFormBuilder,
    ref: ChangeDetectorRef,
    context: WorkflowContextService 
  ) {
    super(layoutService, componentFactoryResolver, ref, context);
  }

  ngOnInit() {}

  selectChange() {
    // the checkbox only passes true/false - convert to yes/no
    if (this.checkBoxValue === true) {
      this.entity.value = 'Yes';
    }
    if (this.checkBoxValue === false) {
      this.entity.value = 'No';
    }
  }
}
